import FarmsPanel from "./FarmsPanel";

export default FarmsPanel;